import { createAction, handleActions } from 'redux-actions'

/***
 * Common Actions
 *
 * The following actions are globally recognized by one or more subreducers.
 */
export const RESET_GAME = 'BPF_4075/RESET_GAME'
export const resetGame = createAction(RESET_GAME)

export const SET_USER_UID = 'BPF_4075/player/SET_USER_UID'
export const SET_IS_OVER_18 = 'BPF_4075/player/SET_IS_OVER_18'
export const SET_FIRST_NAME = 'BPF_4075/player/SET_FIRST_NAME'
export const SET_LAST_NAME = 'BPF_4075/player/SET_LAST_NAME'
export const SET_ZIP_CODE = 'BPF_4075/player/SET_ZIP_CODE'
export const SET_SCHOOL = 'BPF_4075/player/SET_SCHOOL'
export const SET_TEACHER_NAME = 'BPF_4075/player/SET_TEACHER_NAME'
export const SET_ISLAND = 'BPF_4075/player/SET_ISLAND'
export const SET_EMAIL = 'BPF_4075/player/SET_EMAIL'
export const SET_SUBSCRIBE_TO_NEWSLETTER =
  'BPF_4075/player/SET_SUBSCRIBE_TO_NEWSLETTER'

const initialState = {
  uid: null,
  isOver18: null,
  firstName: '',
  lastName: '',
  zipCode: '',
  school: '',
  teacherName: '',
  email: '',
  island: '',
  subscribeToNewsletter: true,
}

export default handleActions(
  {
    // Reset all game state.
    [RESET_GAME]: () => ({ ...initialState }),

    // Sets the user uid.
    [SET_USER_UID]: (state, { payload }) => ({
      ...state,
      uid: payload,
    }),

    // Sets the player's age.
    [SET_IS_OVER_18]: (state, { payload }) => ({
      ...state,
      isOver18: payload,
    }),

    // Sets the player's first name.
    [SET_FIRST_NAME]: (state, { payload }) => ({
      ...state,
      firstName: payload,
    }),

    // Sets the player's lastname.
    [SET_LAST_NAME]: (state, { payload }) => ({
      ...state,
      lastName: payload,
    }),

    // Sets the player's zip code.
    [SET_ZIP_CODE]: (state, { payload }) => ({
      ...state,
      zipCode: payload,
    }),

    // Sets the player's school.
    [SET_SCHOOL]: (state, { payload }) => ({
      ...state,
      school: payload,
    }),

    // Sets the player's teacher's name.
    [SET_TEACHER_NAME]: (state, { payload }) => ({
      ...state,
      teacherName: payload,
    }),

    [SET_ISLAND]: (state, { payload }) => ({
      ...state,
      island: payload,
    }),

    // Sets the player's email address.
    [SET_EMAIL]: (state, { payload }) => ({
      ...state,
      email: payload,
    }),

    // Sets the player's agreement to subscribe to the newsletter.
    [SET_SUBSCRIBE_TO_NEWSLETTER]: (state, { payload }) => ({
      ...state,
      subscribeToNewsletter: Boolean(payload),
    }),
  },
  initialState,
)

export const setUserUID = createAction(SET_USER_UID)
export const setIsOver18 = createAction(SET_IS_OVER_18)
export const setFirstName = createAction(SET_FIRST_NAME)
export const setLastName = createAction(SET_LAST_NAME)
export const setZipCode = createAction(SET_ZIP_CODE)
export const setSchool = createAction(SET_SCHOOL)
export const setTeacherName = createAction(SET_TEACHER_NAME)
export const setIsland = createAction(SET_ISLAND)
export const setEmail = createAction(SET_EMAIL)
export const setSubscribeToNewsletter = createAction(
  SET_SUBSCRIBE_TO_NEWSLETTER,
)



// WEBPACK FOOTER //
// ./src/modules/player.js